import React, { Component, useRef } from "react";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import successIcon from "../../../../../Assets/img/svg/Check.svg"
import errorIcon from "../../../../../Assets/img/svg/cancelerror.svg"
import { TextField } from "@material-ui/core";
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery";
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../../Assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import moment from "moment"
import axios from "axios";
import API from "../../../../../helpers/endpointService"
    ; import { CssTextField } from "../../../../custom/textField"
import { inspectionSystem } from "../../../../Constants";
import { warningAlert, successAlert } from "../../../../custom/alert"

class AddEditCargo extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            successId: 0,
            isSuccess: false,
            isFailure: false,
            isSuccessComment: false,
            isFailureComment: false,
            CommentId: "",
            ShipId: 0,
            UserRole: "",
            isMobile: false,
            isView: false,
            DocsName: [],
            CargoSystem: [],
            CargoSystemComments: "",
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ShipId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.InspectionId = parseInt(localStorage.getItem("InspectionId"));
        this.setState({})
        this.CargoSystemTable();
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.interval = setInterval(() => {
            this.resize1();
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#TRAIN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Cargotank1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Cargtank").addClass("d-none");
        $("#Cargtank").removeClass("d-block");
        $("#TML").removeClass("active-color");
        $("#TMT").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#TRAIN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Cargotank1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Cargtank").removeClass("d-none");
        $("#Cargtank").addClass("d-block");
        $("#TML").addClass("active-color");
        $("#TMT").addClass("fw-bolder");
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    OpenPopup = () => {
        window.$("#deletepopup").modal("show")
    }

    CargoSystemTable = () => {
        let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.CargoTanks}&inspectionId=${this.state.InspectionId}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true });
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        CargoSystem: response?.data,
                    }, () => {
                        this.state.CargoSystem?.Questions.map((i) => (
                            i?.AnswersList?.sort((a, b) => {
                                return a.CategoryId - b.CategoryId;
                            }),
                            i?.AnswersList?.map((c) => (
                                c.AnswerLookupList?.sort((s, a) => {
                                    return s.Id - a.Id;
                                })
                            )),
                            i?.AnswersList1?.sort((a, b) => {
                                return a.CategoryId - b.CategoryId;
                            }),
                            i?.AnswersList1?.map((c) => (
                                c.AnswerLookupList?.sort((s, a) => {
                                    return s.Id - a.Id;
                                })
                            ))
                        ))
                        this.setState({})
                        $.each(this.state.CargoSystem?.Questions, function (i, val) {
                            $(".system input[value='" + val.CheckId + "']").prop('checked', true);
                        });
                        this.GetCargoSystemComments();
                    });
                    this.props.dispatch({ type: "SHOW_LOADER", data: false });
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false });
                if (error?.response?.status === 401) {
                }
            });
    };
    /* Checklist comments code */
    handleInputCommentChange = (e, field) => {
        if (field === "CargoSystem") {
            this.state.CargoSystemComments = e.target.value;
        }
        this.state.CommentId = field;
        this.setState({})
    }
    updateOperationalComments = (e, field) => {
        const currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let shipId = parseInt(this.state.ShipId)
        let data = {
            shipId: shipId,
            sectionId: 0,
            comments: "",
            modifiedBy: currentUser.email
        }
        if (field === "CargoSystem") {
            data.sectionId = inspectionSystem.CargoTanks;
            data.comments = this.state.CargoSystemComments;
        }
        this.UpdateChecklistComments(data)
    }
    UpdateChecklistComments = (data) => {
        let apiUrl = `${API.AddEdit_checklist_comments}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.GetCargoSystemComments();
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                    this.setState({ isSuccessComment: true })
                    setTimeout(() => {
                        this.setState({ isSuccessComment: false, CommentId: 0, })
                    }, 3000);
                } else {
                    this.setState({ isFailureComment: true })
                    setTimeout(() => {
                        this.setState({ isFailureComment: false, CommentId: 0 })
                    }, 3000);
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                this.setState({ isFailureComment: true })
                setTimeout(() => {
                    this.setState({ isFailureComment: false, CommentId: 0 })
                }, 3000);
                if (error?.response?.status === 401) {
                }
            });
    }

    GetCargoSystemComments = () => {
        let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.CargoTanks}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.CargoSystemComments = response.data.comments;
                    this.setState({});
                    this.props.dispatch({ type: "SHOW_LOADER", data: false });
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false });
                if (error?.response?.status === 401) {
                }
            });
    }

    handleInputChange = (e, str, s, array, array1) => {
        this.state.successId = str.QuestionId;
        this.state.isSuccess = false;
        this.state.isFailure = false;
        this.setState({})
        let string = true;
        if (s.CategoryId !== 0 && s.CategoryId != undefined) {
            if (array1?.Id === array?.Id) {
                string = false;
                this.state.CargoSystem && this.state.CargoSystem?.Questions?.map((i, ind) => (
                    i.QuestionId == str.QuestionId ? i?.AnswersList1?.length != 0 ? i?.AnswersList1?.map((a, index1) => (
                        a.CategoryName == s.CategoryName ? i?.AnswersList1?.splice(index1, 1) : ""
                    )) : "" : ""
                ))
                this.setState({})
            }
            else {
                var data1 = {
                    Id: array.Id,
                    CategoryId: s.CategoryId,
                    CategoryName: s.CategoryName,
                    AnswerLookupList: [{ Id: array1?.AnswerLookupList[0]?.Id, "Answer": array.Answer }],
                }
                this.state.CargoSystem && this.state.CargoSystem?.Questions?.map((i, ind) => (
                    i.QuestionId == str.QuestionId ? i?.AnswersList1?.length != 0 ? i?.AnswersList1?.map((a, index1) => (
                        a.CategoryName == s.CategoryName ? i?.AnswersList1?.splice(index1, 1) : ""
                    )) : "" : "",
                    i.QuestionId == str.QuestionId ?
                        (i?.AnswersList1 === null || i?.AnswersList1.length === 0) ? i?.AnswersList1.push(data1) :
                            (i?.AnswersList1.length > 0) ?
                                i?.AnswersList1?.map((a, indexs) => a.CategoryId === s.CategoryId ? a.Id = array.Id : i?.AnswersList1.push(data1))
                                : i?.AnswersList1.push(data1) : ""
                ))
                this.setState({})
            }
        }
        this.state.CargoSystem && this.state.CargoSystem?.Questions.map((i) => (
            i.AnswersList?.sort((a, b) => {
                return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList?.map((c) => (
                c.AnswerLookupList?.sort((s, a) => {
                    return s.Id - a.Id;
                })
            )),
            i.AnswersList1?.sort((a, b) => {
                return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList1?.map((c) => (
                c.AnswerLookupList?.sort((s, a) => {
                    return s.Id - a.Id;
                })
            ))
        ))
        this.setState({})
        let data = {
            QuestionId: str.QuestionId,
            AnswerType: str.AnswerType,
            AnswerId: string === false ? 0 : array.Id,
            InspectionId: this.state.InspectionId,
            Id: array1?.AnswerLookupList[0]?.Id == undefined ? 0 : array1?.AnswerLookupList[0]?.Id,
            AnswerCategory: s.CategoryId,
            Answer: array.Answer,
            MultipleAnswerIds: "",
            CreatedBy: this.state.UserRole
        }
        if (data.Id === 0) {
            this.post_cargoStatus(data);
        } else {
            this.put_cargoStatus(data, data?.Id)
        }
    }
    handleInputChange1 = (e, str) => {
        this.state.successId = str.QuestionId;
        this.state.isSuccess = false;
        this.state.isFailure = false;
        this.setState({})
        this.state.CargoSystem && this.state.CargoSystem?.Questions?.map((i, ind) => (
            i.AnswerId == str.AnswerId ? str.Answer = e.target.value : ""
        ))
        this.setState({})
    }
    updatemastercomments = (e, str) => {
        let data = {
            QuestionId: str.QuestionId,
            AnswerType: str.AnswerType,
            AnswerId: str.CheckId ? str.CheckId : 0,
            InspectionId: this.state.InspectionId,
            Id: str.AnswerId === null ? 0 : str.AnswerId,
            AnswerCategory: 0,
            Answer: e.target.value.trim(),
            MultipleAnswerIds: "",
            CreatedBy: this.state.UserRole
        }
        if (data.Id === 0) {
            this.post_cargoStatus(data)
        } else {
            this.put_cargoStatus(data, data.Id)
        }
    }
    updatemastercomments2 = (e, str, Id, AnswerId) => {
        let data = {
            QuestionId: str.QuestionId,
            AnswerType: str.AnswerType,
            AnswerId: 0,
            InspectionId: this.state.InspectionId,
            Id: (AnswerId === null || AnswerId === undefined) ? 0 : AnswerId,
            AnswerCategory: Id,
            Answer: e.target.value.trim(),
            MultipleAnswerIds: "",
            CreatedBy: this.state.UserRole
        }
        if (data.Id === 0) {
            this.post_cargoStatus(data)
        } else {
            this.put_cargoStatus(data, data.Id)
        }
    }
    post_cargoStatus = (data) => {
        let apiUrl = `${API.AddEdit_checklist}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.CargoSystemTable();
                    this.setState({ isSuccess: true })
                    setTimeout(() => {
                        if (this.state.isSuccess === true) {
                            this.setState({ isSuccess: false, successId: 0, })
                        }
                    }, 2000);
                } else {
                    this.setState({ isFailure: true })
                    setTimeout(() => {
                        if (this.state.isFailure === true) {
                            this.setState({ isFailure: false, successId: 0 })
                        }
                    }, 3000);
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                this.setState({ isFailure: true })
                setTimeout(() => {
                    if (this.state.isFailure === true) {
                        this.setState({ isFailure: false, successId: 0 })
                    }
                }, 3000);
                if (error?.response?.status === 401) {
                }
            });
    }
    put_cargoStatus = (data, Id) => {
        let apiUrl = `${API.AddEdit_checklist}?id=${Id}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.CargoSystemTable();
                    this.setState({ isSuccess: true })
                    setTimeout(() => {
                        if (this.state.isSuccess === true) {
                            this.setState({ isSuccess: false, successId: 0, })
                        }
                    }, 2000);
                } else {
                    this.setState({ isFailure: true })
                    setTimeout(() => {
                        if (this.state.isFailure === true) {
                            this.setState({ isFailure: false, successId: 0 })
                        }
                    }, 3000);
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                this.setState({ isFailure: true })
                setTimeout(() => {
                    if (this.state.isFailure === true) {
                        this.setState({ isFailure: false, successId: 0 })
                    }
                }, 3000);
                if (error?.response?.status === 401) {

                }
            });
    }

    AddCancel1 = () => {
        this.props.navigate(`/shiplist`)
    }

    handleInputChange2 = (e, str, Id, Name) => {
        this.state.successId = str.QuestionId;
        this.state.isSuccess = false;
        this.state.isFailure = false;
        this.setState({})
        var data = {
            Id: 0,
            CategoryId: Id,
            CategoryName: Name,
            AnswerLookupList: [{ Id: 0, "Answer": e.target.value }],
        }
        this.state.CargoSystem && this.state.CargoSystem?.Questions?.map((i, ind) => (
            i.QuestionId == str.QuestionId ?
                (i?.AnswersList1 === null || i?.AnswersList1.length === 0) ? i?.AnswersList1.push(data) :
                    (i?.AnswersList1.length > 0) ?
                        i?.AnswersList1?.map((a, indexs) => a.CategoryId === Id ? a.AnswerLookupList[0].Answer = e.target.value : i?.AnswersList1.push(data))
                        : i?.AnswersList1.push(data) : ""
        ))
        this.state.CargoSystem && this.state.CargoSystem?.Questions.map((i) => (
            i.AnswersList?.sort((a, b) => {
                return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList?.map((c) => (
                c.AnswerLookupList?.sort((s, a) => {
                    return s.Id - a.Id;
                })
            )),
            i.AnswersList1?.sort((a, b) => {
                return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList1?.map((c) => (
                c.AnswerLookupList?.sort((s, a) => {
                    return s.Id - a.Id;
                })
            ))
        ))
        this.setState({})
    }

    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 border-bottom mt-4 mob-topfixed">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"TRAIN" + "1"} className='  textNaviIcon' primary="Inspection Tasks" />
                                            <NavigateNextIcon id="TRAIN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Cargo Tanks </h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide mt-138" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
                    {this.state.isMobile ? (
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center">
                                        <i
                                            class="fa fa-arrow-left cursorPointer"
                                            onClick={this.AddCancel1}
                                        ></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        <>
                            <table className="dataTable" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="5%" className="border-right text-center">
                                            <i
                                                class="fa fa-arrow-left cursorPointer"
                                                onClick={this.AddCancel1}
                                            ></i>
                                        </td>
                                        <td className="" width="95%">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    )}
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-12 pt-2">
                                {this.state.isMobile ? <></> : <h6>Vessel Capabilities and Cargo Systems - Tanker</h6>}
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="border-top section-color spandoc-thead">
                                            <th className="border-right border-left" colSpan="6"><span className="spandoc-thead">Cargo Tanks</span></th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {this.state.CargoSystem && this.state.CargoSystem?.Questions?.map((i, ind) => (
                                            <>
                                                <tr className="border-top system" onMouseEnter={() => this.setState({ HoverId: i.Id })} onMouseLeave={() => this.setState({ HoverId: 0 })}>
                                                    <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td1" : "docwidth-td1"} border-right align-middle`}>
                                                        <span className="spandoc-td">{i.QuestionDescription}</span>
                                                    </td>
                                                    {(i?.AnswersList === null || i?.AnswersList.length === 0) ? <>
                                                        <td className="commentsrequire-td align-middle" colSpan={2}>
                                                            <span className="spandoc-td">
                                                                <CssTextField
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    onChange={(e) => this.handleInputChange1(e, i)}
                                                                    onBlur={(e) => this.updatemastercomments(e, i)}
                                                                    value={i?.Answer}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                                                    }}
                                                                />
                                                            </span>
                                                        </td>
                                                    </> : <>
                                                        <td className="spanstatusnormal-thead2 border-right align-middle">
                                                            <div className="spandoc-td">
                                                                <label style={{ color: "#000000", padding: 5 }} ><input type="radio" className="checkboxradio" name={`muhRadio${i.QuestionId}`} id={`Generalyes${i.QuestionId}`} value={i?.AnswersList[0]?.AnswerLookupList[0]?.Id} checked={i?.AnswersList1?.filter((j) => j.CategoryName === "Tanker1")[0]?.Id === i?.AnswersList[0]?.AnswerLookupList[0]?.Id ? true : false} onClick={(e) => { this.handleInputChange(e, i, i?.AnswersList?.filter((j) => j.CategoryName === "Tanker1")[0], i?.AnswersList?.filter((j) => j.CategoryName === "Tanker1")[0]?.AnswerLookupList[0], i?.AnswersList1?.filter((j) => j.CategoryName === "Tanker1")[0]) }} style={{ color: "rgba(0, 0, 0, 0.54)" }} /><span className="checkboxtext" style={{ verticalAlign: "top" }}>{i?.AnswersList[0]?.AnswerLookupList[0]?.Answer}</span></label>
                                                            </div>
                                                        </td>
                                                        <td className="commentsrequire-td align-middle">
                                                            <span className="spandoc-td">
                                                                <CssTextField
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    value={i?.AnswersList1 != null && i?.AnswersList1?.filter((j) => j.CategoryName === "Tanker2")[0]?.AnswerLookupList[0]?.Answer ? i?.AnswersList1?.filter((j) => j.CategoryName === "Tanker2")[0]?.AnswerLookupList[0]?.Answer : ""}
                                                                    onChange={(e) => this.handleInputChange2(e, i, i?.AnswersList[1]?.CategoryId, i.AnswersList[1]?.CategoryName)}
                                                                    onBlur={(e) => this.updatemastercomments2(e, i, i?.AnswersList[1]?.CategoryId, i?.AnswersList1?.filter((j) => j.CategoryName === "Tanker2")[0]?.AnswerLookupList[0]?.Id)}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                                                    }}
                                                                />
                                                            </span>
                                                        </td>
                                                    </>}
                                                    <td width="4%" className="border-right text-center align-middle">{i.QuestionId === this.state.successId && this.state.isSuccess === true ?
                                                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                                                        {i.QuestionId === this.state.successId && this.state.isFailure === true ? <span className="spandoc-error-img">
                                                            <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                                                </tr>
                                            </>))}
                                        <tr className="border-right border-top text-center align-middle">
                                            <td colSpan={3}>
                                                <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                                                <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                                                    InputProps={{
                                                        className: `border-radius mt-1 ${classes.inputfieldAlign}`,
                                                        style: { fontSize: 12 }
                                                    }}
                                                    value={this.state.CargoSystemComments}
                                                    type="text"
                                                    onChange={(e) => this.handleInputCommentChange(e, "CargoSystem")}
                                                    onBlur={(e) => this.updateOperationalComments(e, "CargoSystem")} />
                                            </td>
                                            <td width="4%" className="border-right text-center align-middle">{"CargoSystem" === this.state.CommentId && this.state.isSuccessComment === true ?
                                           <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"CargoSystem" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </div>
                </div>

            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddEditCargo))
);
